<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card class="pa-4">
      <v-card-title>
        <div class="errorTitle">
          {{ title }}
        </div>
      </v-card-title>
      <v-card-text class="errorMessage">
        <div style="text-align: center">
          {{ message }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="action"
          class="actionButton"
          @click="$emit('handleAction')"
        >
          {{ action }}
        </v-btn>
        <v-btn
          class="dismissButton"
          color="primary"
          outlined
          @click="dialog = !dialog"
        >
          OK
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['value', 'title', 'message', 'action'],

    data() {
      return {
        dialog: this.value,
      };
    },

    computed: {},

    watch: {
      value: {
        handler(val) {
          this.dialog = val;
        },
      },
      dialog: function(val) {
        this.$emit('input', val);
      },
    },

    methods: {},
  };
</script>

<style scoped>
  .errorTitle {
    font-family: Assistant;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
  }
  .errorMessage {
    font-family: Assistant;
    font-style: normal;
    font-weight: regular;
    font-size: 16px;
    line-height: 20px;
  }
  .actionButton {
    font-family: Assistant;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    height: 40px;
  }
  .dismissButton {
    font-family: Assistant;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    height: 40px;
  }
</style>
